// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.accessibility__radio-label input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 1px;\n  height: 1px;\n  opacity: 0.00000001;\n}\n", ""]);
// Exports
module.exports = exports;
